<!-- eslint-disable @angular-eslint/template/eqeqeq -->
<div [attr.inert]="!isSidenav && isMylearning ? true : null" class="tab-wrp tab-wrpguide pb-5"
    [class.mt-0]="!isSplitScreen"
    [ngClass]="{'ts-tabs-panel top-adjustment': appType === 'attendee' || appType === 'trial'}" *ngIf="!loading">
    <div class="custom-tab-main">
        <div class="d-flex align-items-center justify-content-start w-100">
            <!-- Accessibility issue: Element has children which are not allowed, Once functionality done then we will take it -->
            <ul class="nav nav-tabs resize-tab tabs_1 tab-width ts-tabs-list" role="tablist">
                <li id="link_{{item.id}}" class="nav-item" role="presentation"
                    *ngFor="let item of guideTab; let i = index;">
                    <a class="nav-link ts-tab-item" id="main-landmark{{i}}" role="tab"
                        [appArrowKeysAccessible]="'arrow-key-doc-guide'" style="text-decoration: none;"
                        [attr.aria-selected]="item.selected" [ngClass]="{'active-tab': tabView === item.link}"
                        (click)="viewTab(item.link, item, false, false)" href="javascript:void(0)"><b
                            [translate]="item.title"></b></a>
                </li>
                <ul class="nav nav-tabs tabs_1 dropdown-ul m-0 p-0 ts-tabs-list">
                    <li class="nav-item dropdown custom-dropdown-tab"
                        [ngClass]="{'attendee-droppdown': appType === 'attendee' || appType === 'trial'}">
                        <a href="javascript:void(0)" role="button" aria-label="More items" id="myTabDrop1"
                            class="ts-tab-item nav-tabs more-link" data-toggle="dropdown"
                            aria-controls="myTabDrop1-contents" aria-expanded="false">
                            <b id="showdropdown-menu" [title]="'SHOW_DROP_DOWN_TOOL_TIP' | translate">{{'MORE'
                                |translate}} <i class="fas fa-chevron-down ml-2 more-icon-position"></i></b>
                        </a>
                        <ul class="dropdown-menu" aria-labelledby="myTabDrop1" id="myTabDrop1-contents" role="tablist">
                            <li id="link_{{item.id}}-dup" class="nav-item" *ngFor="let item of guideTab; let i = index;"
                                role="presentation">
                                <a role="tab" [appArrowKeysAccessible]="'arrow-key-doc-guide-dp'"
                                    [attr.aria-selected]="item.selected" style="text-decoration: none;"
                                    class="nav-link ts-tab-item"
                                    [ngClass]="{'active-tab': tabView === item.link, 'active': appType === 'lab' && tabView === item.link}"
                                    (click)="viewTab(item.link, item, false, false)" href="javascript:void(0)"><b
                                        [translate]="item.title"></b></a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </ul>
        </div>
        <ng-container *ngIf="showSplitWindow">
            <div class="toggle-icons">
                <div class="line"></div>
                <a *ngIf="!isSplitScreen" role="button" href="javascript:void(0)"
                    [attr.aria-label]="'SPLIT_WINDOW' | translate" [title]="'SPLIT_WINDOW' | translate"
                    (click)="splitWindow()">
                    <img src="assets/images/split_window_icon-colour.svg" alt="">
                </a>
                <a *ngIf="isSplitScreen" role="button" href="javascript:void(0)"
                    [attr.aria-label]="'JOIN_WINDOW' | translate" [title]="'JOIN_WINDOW' | translate"
                    (click)="joinWindow()">
                    <img src="assets/images/join_window_icon.svg" alt="">
                </a>
            </div>
        </ng-container>

    </div>
    <div class="content-wrp mt-2">
        <div class="tab-content" id="lab-guide-tab">
            <div *ngIf="tabView === 'guide' && gitHUbdocs?.EnableLabGuidePageDuration &&
            gitHUbdocs?.Files[this.activePageIndex]?.PageDuration && gitHUbdocs?.Files[this.activePageIndex]?.PageDuration > 0"
                class="d-flex justify-content-center p-2 main-lab-duration-sec">
                <div class="duration-box d-flex align-items-center">
                    <div class="left-block">
                        <ng-container *ngIf="!this.gitHUbdocs?.Files[activePageIndex].isCompleted; else completedText">
                            {{"DURATION_TO_FINISH" | translate}}
                        </ng-container>
                        <ng-template #completedText>
                            {{"COMPLETED_LABEL" | translate}}
                        </ng-template>
                    </div>
                  
                    <div class="center-block">
                      |
                    </div>
                  
                    <div class="right-block">
                        <span *ngIf="!this.gitHUbdocs?.Files[activePageIndex].isCompleted; else completedBlock" 
                            class="time-value" [ngClass]="pageSeconds < 0 ? 'text-danger' : 'text-primary'">
                            {{ pageSeconds | formatTime : true }}
                        </span>
                        <ng-template #completedBlock>
                            <i class="fas fa-check-circle text-success fa-lg"></i>
                        </ng-template>
                    </div>
                </div>
            </div>
            <div class="guide-tabs lab-guide" [class.showtab]="tabView === 'guide'" id="guideView" tabindex="0"
                style="overflow: auto;">
                <div id="guide-page"
                    *ngFor="let item of gitHUbdocs?.Files | paginate: { itemsPerPage: 1, currentPage: p }">

                    <!-- Main loop to iterate over the content split by the testPattern -->
                    <ng-container *ngFor="let data of currentLabguide[p]?.split(testPattern); let i = index">

                        <!-- Render markdown if the data doesn't match the testPattern -->
                        <cloudlabs-markdown
                            *ngIf="!testPattern.test(data) && (!labDetail.EnableInlineValidation && !labDetail?.HasInlineQuestions)"
                            class="variable-binding" [readMeData]="data">
                        </cloudlabs-markdown>

                        <!-- If either validation or questions are enabled -->
                        <ng-container *ngIf="labDetail.EnableInlineValidation || labDetail?.HasInlineQuestions">

                            <!-- Render markdown that does not match the testPattern -->
                            <cloudlabs-markdown *ngIf="!testPattern.test(data)" class="variable-binding"
                                [readMeData]="data"></cloudlabs-markdown>

                            <!-- Inline validation -->
                            <ng-container *ngIf="labDetail.EnableInlineValidation && validationPattern.test(data)">
                                <cloudlabs-lab-validation [voucherCode]="voucherCode" [labDetail]="labDetail"
                                    [isInlineValidation]="true" [stepUniqueId]="data"
                                    (updatePageLock)="updatePageLock()">
                                </cloudlabs-lab-validation>
                            </ng-container>

                            <!-- Inline questions -->
                            <ng-container *ngIf="labDetail?.HasInlineQuestions">

                                <!-- Ungrouped questions -->
                                <ng-container *ngIf="ungroupedQuestPattern.test(data)">
                                    <div class="position-relative">
                                        <cloudlabs-inline-question [questIndex]="i" [questionStyle]="'ungroupedQuest'"
                                            [inlineQuestionTag]="data" [pageNumber]="p"
                                            [questionData]="getUngroupQuestionData(data)">
                                        </cloudlabs-inline-question>
                                    </div>
                                </ng-container>

                                <!-- Grouped questions -->
                                <div class="position-relative" *ngIf="groupedQuestPattern.test(data)">
                                    <cloudlabs-inline-question [questIndex]="i" [questionStyle]="'groupedQuest'"
                                        [inlineQuestionTag]="data" [pageNumber]="p"
                                        [questionData]="getGroupQuestionData(data)">
                                    </cloudlabs-inline-question>
                                </div>
                            </ng-container>
                        </ng-container>

                        <!-- Always render inline video when inlineVideoPattern.test(data) is true -->
                        <ng-container *ngIf="inlineVideoPattern.test(data)">
                            <cloudlabs-video [videoTag]="data" [videoLink]="getVideoLink(data)"
                                [videoWidth]="getVideoWidth(data)" [videoHeight]="getVideoHeight(data)">
                            </cloudlabs-video>
                        </ng-container>
                    </ng-container>
                    <ng-container
                        *ngIf="currentLabguide[p] && showDelete && pageNumber == totalPages && currentLabguide[p].trim() !== docGuideErr.ERR_404_NOT_FOUND && currentLabguide[p].trim() !== docGuideErr.ERR_DOC_NOT_FOUND">
                        <!--pageNumber == totalPages DO NOT add 3rd = in this as we are not stricly checking its type | Sheikh -->
                        <cloudlabs-delete-button (actionClickEvent)="onDelete($event)" (markAsCompleteEvent)="markAsComplete()"
                            [showMarkComplete]="tabView === 'guide' && gitHUbdocs.EnableLabGuidePageDuration &&
                            gitHUbdocs?.Files[this.activePageIndex]?.PageDuration &&
                            gitHUbdocs?.Files[this.activePageIndex]?.PageDuration > 0 && !this.gitHUbdocs?.Files[activePageIndex].isCompleted"
                            [showButtonLoading]="btnLoadingService.getLoding()"></cloudlabs-delete-button>
                    </ng-container>

                    <div class="pt-3 d-flex justify-content-end">
                        <teams-button [classList]="'btn ts-btn-fluent-primary modal-ok-button'"
                            *ngIf="tabView === 'guide' && gitHUbdocs.EnableLabGuidePageDuration &&
                            (!showDelete || pageNumber != totalPages) &&
                            gitHUbdocs?.Files[this.activePageIndex]?.PageDuration &&
                            gitHUbdocs?.Files[this.activePageIndex]?.PageDuration > 0 && !this.gitHUbdocs?.Files[activePageIndex].isCompleted"
                            [index]="'markComplete'" [processingTitle]="btnLoadingService.getButtonText()"
                            [showLoading]="btnLoadingService.getLoding()"
                            (buttonClick)="markAsComplete()" [title]="'MARK_COMPLETE' | translate"></teams-button>
                    </div>
                </div>
                <!-- Keep commented code for future POV | Sheikh-->
                <!-- <ng-container *ngIf="gitHUbdocs && gitHUbdocs.Files?.length > 0">
                    <ng-container *ngFor="let item of gitHUbdocs?.Files | paginate: { itemsPerPage: 1, currentPage: p }">
                        <cloudlabs-markdown *ngIf="currentLabguide[p] && (!labDetail.EnableInlineValidation && !labDetail?.HasInlineQuestions)" 
                            class="variable-binding" [readMeData]="currentLabguide[p]"></cloudlabs-markdown>
                            <ng-container *ngIf="labDetail.EnableInlineValidation || labDetail?.HasInlineQuestions">
                                <ng-container *ngFor="let data of currentLabguide[p]?.split(testPattern); let i = index">
                                    <cloudlabs-markdown *ngIf="!testPattern.test(data)" class="variable-binding" [readMeData]="data"></cloudlabs-markdown>
                                    <ng-container *ngIf="labDetail.EnableInlineValidation">
                                        
                                    <cloudlabs-lab-validation *ngIf="validationPattern.test(data)" [voucherCode]="voucherCode" [labDetail]="labDetail"
                                    [isInlineValidation]="true" [stepUniqueId]="data" (updatePageLock)="updatePageLock()"></cloudlabs-lab-validation>
                                    </ng-container>
                                    
                                    <ng-container *ngIf="labDetail?.HasInlineQuestions">
                                        <ng-container *ngIf="ungroupedQuestPattern.test(data)">
                                            <div class="position-relative">
                                                <cloudlabs-inline-question [questIndex] = "i" [questionStyle]="'ungroupedQuest'" [inlineQuestionTag]="data" [pageNumber]="p" [questionData]="getUngroupQuestionData(data)"></cloudlabs-inline-question>
                                            </div>
                                            
                                        </ng-container>
                                        <div class="position-relative"  *ngIf="groupedQuestPattern.test(data)">
                                            <cloudlabs-inline-question [questIndex] = "i" [questionStyle]="'groupedQuest'" [inlineQuestionTag]="data" [pageNumber]="p" [questionData]="getGroupQuestionData(data)"></cloudlabs-inline-question>
                                        </div>
                                    </ng-container>
                                    <ng-container *ngIf="inlineVideoPattern.test(data)">
                                        <cloudlabs-video [videoTag]="data" [videoLink]="getVideoLink(data)" [videoWidth]="getVideoWidth(data)" [videoHeight]="getVideoHeight(data)"></cloudlabs-video>
                                    </ng-container>
                                    
                                </ng-container>
                            </ng-container>
                    </ng-container>
                </ng-container> -->
            </div>
            <div class="guide-tabs p-0" [class.showtab]="tabView === 'environment'">
                <cloudlabs-lab-environment [minGuide]="minGuide" [labDetail]="labDetail" [voucherCode]="voucherCode"
                    (deallocateLab)="completeTheLab($event)" [pasteInVM]="pasteInVM"></cloudlabs-lab-environment>
            </div>
            <div class="guide-tabs" [class.showtab]="tabView === 'validation'"
                *ngIf="(!labDetail?.DisableValidationTab && !this.IsSupportQuestFlag)">
                <cloudlabs-lab-validation [labDetail]="labDetail" [voucherCode]="voucherCode"
                    [manager]="manager"></cloudlabs-lab-validation>
            </div>
            <div class="guide-tabs p-0" [class.showtab]="tabView === 'progress'" *ngIf="labDetail?.EnableLabProgress">

                <cloudlabs-progress-card *ngIf="tabView === 'progress'" class="p-2"
                    [labDetail]="labDetail"></cloudlabs-progress-card>
            </div>
            <ng-container *ngIf="showResourcesTab">
                <!-- *ngIf="this.guideData.CloudPlatformId === 1 || this.guideData.CloudPlatformId === 2 || this.guideData.CloudPlatformId === 3 || this.guideData.CloudPlatformId === 4" -->
                <div class="guide-tabs" [class.showtab]="tabView === 'resources'">
                    <cloudlabs-resource *ngIf="tabView === 'resources'" [labDetail]="labDetail" [mode]="mode"
                        [attendeLabDetails]="guideData" [manager]="manager" [voucherCode]="voucherCode"
                        [splitKey]="splitKey" [isMobile]="isMobile"></cloudlabs-resource>
                </div>
            </ng-container>

            <div class="guide-tabs" [class.showtab]="tabView === 'description'" id="lab-description" tabindex="0">
                <div [innerHTML]="labDetail.LabLaunchPageDescription | targetBlank | sanitizeHtml" tabindex="0"></div>
            </div>

            <div class="guide-tabs help-tab-content" [class.showtab]="tabView === 'help'">
                <cloudlabs-help-tab [deploymentID]="deploymentID" [isMylearning]="isMylearning" [osInfo]="osInfo"
                    [pasteInVM]="pasteInVM" [labTitle]="labDetail.DisplayName || labDetail.Title" [supportEmail]="labDetail.SupportEmail" [attendeLabDetails]="attendeLabDetails"></cloudlabs-help-tab>
            </div>
        </div>

    </div>
    <cloudlabs-pagination-controls [ngClass]="{ 'd-none': tabView !== 'guide'}" [responsive]="true"
        [isLoading]="disablePaginationControls" [previousLabel]="'PREVIOUS' | translate"
        [nextLabel]="'NEXT' | translate" (pageChange)="p = $event; getcalue()">
    </cloudlabs-pagination-controls>
</div>

<!-- Code block full screen popup -->
<cloudlabs-code-block-popup #codeBlockPopup [appType]="appType"></cloudlabs-code-block-popup>
